



















import {mapActions, mapGetters} from 'vuex';
import CustomAtInput from '@/components/CustomAtInput.vue';
import vue from 'vue';

export default vue.extend({
  name: 'SearchInput',

  components: {
    CustomAtInput,
  },

  data: (): { searchValue: string } => ({
    searchValue: '',
  }),

  computed: {
    ...mapGetters([
      'searchOptions',
    ]),
  },

  watch: {
    'searchOptions.lastTerm': function (): void {
      this.searchValue = this.searchOptions.lastTerm;
    },
  },

  mounted() {
    if (this.searchOptions.lastTerm !== '') this.searchValue = this.searchOptions.lastTerm;
  },

  directives: {
    focus: {
      inserted: function (el) {
        // @ts-ignore
        el.querySelector('input')
          .focus();
      },
    },
  },

  methods: {
    ...mapActions([
      'changeSearchFieldStatus',
      'loadSearchResult',
    ]),
    onSendSearch(): void {
      if (this.searchValue === '') {
        this.$emit('close');
      } else {
        this.$router.push({name: 'SearchResult', query: {q: this.searchValue}})
            .then(response => {
              this.loadSearchResult({
                searchTerms: response.query.q,
                actualPath: this.$route.name,
                loadNextPage: false,
              });
            })
            .catch(() => {
              this.searchValue = '';
              this.changeSearchFieldStatus(false);
            });
      }
    },
    /**
     * Sélectionne tout le text dans le champs quand on clique pour permettre une modification plus rapide
     *
     * @param {MouseEvent|FocusEvent} event
     */
    onSelectAll(event: Event) {
      (event.target as HTMLInputElement)?.select();
    },
  },
});
